import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
// element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/js/flexable.js';
import '@/styles/index.scss'
const app = createApp(App)
app.use(createPinia()).use(ElementPlus)
app.use(router)
app.mount('#app')

